import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetSocketStateById(params) {
  return maintainRequest({
    url: "/device/maintenanceMan/socket/agentGetSocketStateById",
    params,
  });
}
